import React from 'react';
import { Link } from 'react-router-dom';
import HarbourStatusChip from '../../components/harbour/HarbourStatusChip';
import HarbourPathwayMark from '../../components/harbour/HarbourPathwayMark';
import HarbourIcon from '../../components/harbour/HarbourIcon';
import { familyCardChip, familyCardReferralLines } from '../../utils/familyPortal';
import './familyYourChildren.css';

/*
 * One child on Your children. The whole card is one link to the child's page.
 * Mobile (440 frames): name, year and school, then each pathway as a label
 * line with its chip on its own line. Desktop (Harbour/Child card): a 536
 * card with name and meta on one baseline row and each pathway as an inline
 * row — lane eyebrow in a fixed label column, chip beside it. A pathway the
 * child is not on is hidden. The layout switch is CSS-only.
 *
 * A child referred for ADHD and autism gets a line per referral, each with
 * its own chip (TDI-691); one referral keeps the "Referral pathway" line.
 */
export default function FamilyChildCard({ child, linkState }) {
  if (!child) return null;
  const referralLines = familyCardReferralLines(child.referral);
  return (
    <Link
      to={`/rms/family/child/${child.id}`}
      state={linkState}
      className="family-child-card"
      aria-label={[
        child.name,
        child.sen && 'SEND pathway',
        ...referralLines.map((line) => line.a11y),
      ].filter(Boolean).join(', ')}
    >
      <div className="family-child-card__identity">
        <div className="family-child-card__names">
          <span className="family-child-card__name">{child.name}</span>
          {child.meta && <span className="family-child-card__meta">{child.meta}</span>}
        </div>
        <span className="family-child-card__chevron">
          <HarbourIcon name="chevron-right" size={24} />
        </span>
      </div>
      <div className="family-child-card__pathways">
        {child.sen && (
          <div className="family-status-row">
            <span className="family-status-row__label">
              <HarbourPathwayMark pathway="sen" />
              SEND pathway
            </span>
            <HarbourStatusChip {...familyCardChip(child.sen)} />
          </div>
        )}
        {referralLines.map((line) => (
          <div key={line.key} className="family-status-row">
            <span className="family-status-row__label">
              <HarbourPathwayMark pathway="referral" />
              {line.label}
            </span>
            <HarbourStatusChip {...line.chip} />
          </div>
        ))}
      </div>
    </Link>
  );
}
